import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import VirtualizedSelect from "react-virtualized-select";
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import {
    fetchSimulatorInfo,
    fetchModelInfo,
    fetchModelVersionInfo,
    fetchFeatureInfo,
    fetchBaseScenarioInfo,
    fetchVariationListInfo,
    selectedBaseScenario,
} from "../../../actions/closeLoop/scenarioCollection/dropDownModalAction";
import {
    cartCountUpdate,
    selectedScenarioUuidList,
    selectedScenarioNameList,
    bulkSelectedScenarioList,
    cartCount,
    setCurrentPageNumber,
} from "./../../../actions/closeLoop/scenarioCollection/addToCartScenarioCollectionAction";

function dropDownModal(props) {
    const [simulatorSelected, setSimulatorSelected] = useState("");
    const [modelSeleted, setModelSeleted] = useState("");
    const [versionSeleted, setVersionSeleted] = useState("");
    const [featureSelected, setFeatureSelected] = useState("");
    const [baseScenarioSelected, setBaseScenarioSelected] = useState("");
    const [selectAllVaritationPopup, setSelectAllVaritationPopup] = useState(false);
    const [onSubmit, setOnSubmit] = useState(false);
    const [scenarioGroupNumber, setSelectedTotalVariation] = useState(0);
    const [selectedTotalVariationFlag, setSelectedTotalVariationFlag] = useState(false);
    const [deselectBulkvariations, setDeselectBulkvariations] = useState(false);
    const [data,setData]=useState([])

    useEffect(() => {
        props.simulatorList();
        props.variationList();
        const obj = {
            count: 0,
            items: [],
        };
        props.cartCountUpdate(obj);
        props.selectedScenarioUuidList([]);
        props.selectedScenarioNameList([]);
    }, []);

    let simOptions = [];
    let modelOptions = [];
    let modelVersionOptions = [];
    let featureOptions = [];
    let baseScenarioOptions = [];
    if (props.simulatorListInfo.length > 0) {
        simOptions = props.simulatorListInfo.map((simLabel) => {
            return { label: simLabel };
        });
    } else {
        simOptions = [];
    }

    function onSimulatorChange(selectVal) {
        setSimulatorSelected(selectVal);
        setModelSeleted("");
        setVersionSeleted("");
        setFeatureSelected("");
        setBaseScenarioSelected("");
        setOnSubmit(false);
        props.variationList();
        const obj = {
            count: 0,
            items: [],
        };
        props.cartCountUpdate(obj);
        props.selectedScenarioUuidList([]);
        props.selectedScenarioNameList([]);
        props.cartCount(0);
        props.bulkSelectedScenarioList({});
    }

    if (Object.keys(simulatorSelected).length > 0) {
        modelOptions = props.modelListInfo.map((modelLabel) => {
            return { label: modelLabel };
        });
    } else {
        modelOptions = [];
    }

    function onModelChange(selectVal) {
        setModelSeleted(selectVal);
        setVersionSeleted("");
        setFeatureSelected("");
        setBaseScenarioSelected("");
        setOnSubmit(false);
        props.variationList();
        const obj = {
            count: 0,
            items: [],
        };
        props.cartCountUpdate(obj);
        props.selectedScenarioUuidList([]);
        props.selectedScenarioNameList([]);
        props.cartCount(0);
        props.bulkSelectedScenarioList({});
    }

    if (Object.keys(modelSeleted).length > 0) {
        modelVersionOptions = props.modelVersionListInfo.map((modelVersionLabel) => {
            return { label: modelVersionLabel };
        });
    } else {
        modelVersionOptions = [];
    }

    function onVersionChange(selectVal) {
        setVersionSeleted(selectVal);
        setFeatureSelected("");
        setBaseScenarioSelected("");
        setOnSubmit(false);
        props.variationList();
        const obj = {
            count: 0,
            items: [],
        };
        props.cartCountUpdate(obj);
        props.selectedScenarioUuidList([]);
        props.selectedScenarioNameList([]);
        props.cartCount(0);
        props.bulkSelectedScenarioList({});
    }

    if (Object.keys(versionSeleted).length > 0) {
        featureOptions = props.featureListInfo.map((featureLabel) => {
            return { label: featureLabel };
        });
    } else {
        featureOptions = [];
    }

    function onFeatureChange(selectVal) {
        setFeatureSelected(selectVal);
        setBaseScenarioSelected("");
        setOnSubmit(false);
        props.variationList();
        // const obj = {
        //     count: 0,
        //     items: [],
        // };
        // props.cartCountUpdate(obj);
        // props.selectedScenarioUuidList([])
        // props.selectedScenarioNameList([])
    }

    if (Object.keys(featureSelected).length > 0) {
        baseScenarioOptions = props.baseScenarioListInfo.map((baseScenarioLabel) => {
            return { label: baseScenarioLabel };
        });
    } else {
        baseScenarioOptions = [];
    }

    function onBaseScenarioChange(selectVal) {
        setBaseScenarioSelected(selectVal);
        setOnSubmit(false);
        props.variationList();
        // const obj = {
        //     count: 0,
        //     items: [],
        // };
        // props.cartCountUpdate(obj);
        // props.selectedScenarioUuidList([])
        // props.selectedScenarioNameList([])
    }

    function resetDropDownMenu() {
        setSimulatorSelected("");
        setModelSeleted("");
        setVersionSeleted("");
        setFeatureSelected("");
        setBaseScenarioSelected("");
        setOnSubmit(false);
        props.variationList();
        props.cartCount(0);
        const obj = {
            count: 0,
            items: [],
        };
        props.cartCountUpdate(obj);
        props.selectedScenarioUuidList([]);
        props.selectedScenarioNameList([]);
        props.bulkSelectedScenarioList({});
    }
    function resetCartData(){
        console.log("enter reset Cart Data")
        setDeselectBulkvariations(false)
        const obj = {
            count: 0,
            items: [],
        };
//        props.cartCountUpdate(obj);
        props.selectedScenarioUuidList([]);
        props.selectedScenarioNameList([]);
        // setData([])
        console.log(data)
 
        if(data.length){
            // data.forEach((e)=>{
            //     console.log(e)
            //     if(e.includes(baseScenarioSelected.label)){

            //     }
            // })
            console.log("enter")
            let count=0
            let value=0
            let selectedScenarioObj={}
            let arr=[]
            data.forEach((item,index)=>{
                if(!item.includes(baseScenarioSelected.label)){
                    count=count+item[5]
                    selectedScenarioObj[item[4]]=item[5]
                    arr.push(item)
                }
            })


            // let arr = data.filter(function(item) {
 
            //     if( item.includes(baseScenarioSelected.label) !== true){
            //         count=count+item[5]
 

            //         return true
            //     }
            //     else{
            //         selectedScenarioObj[baseScenarioSelected.label]=item[5]
 
            //         value=item[5]
 
            //     }
            // })
            setData(arr)
            console.log("@@@@@@@@@@@@@@@",selectedScenarioObj,arr,count-value)
            props.cartCount(count);
            props.bulkSelectedScenarioList(selectedScenarioObj);
 
 
        }
        else{
            props.cartCount(0);
            props.bulkSelectedScenarioList({});
 

        }
 
    }
    function submitDropDownMenu() {
        for (let value in data) {
                console.log("#######", data[value])
                if (data[value].length === 0) {
                    setDeselectBulkvariations(false)
                }
                else {
                        if (data[value].includes(simulatorSelected.label) && data[value].includes(modelSeleted.label)
                        && data[value].includes(versionSeleted.label) &&
                        data[value].includes(featureSelected.label) &&
                        data[value].includes(baseScenarioSelected.label)) {
                        console.log("@@@@@@@IFFFFF", data[value])
                            setDeselectBulkvariations(true)
                            break;
                        }
                        else {
                                console.log("@@@@@@@ELSE", data[value])
                                setDeselectBulkvariations(false)
                        }
                }
        }
        if (
            simulatorSelected["label"] != undefined &&
            modelSeleted["label"] != undefined &&
            versionSeleted["label"] != undefined &&
            featureSelected["label"] != undefined &&
            baseScenarioSelected["label"] != undefined
        ) {
            setOnSubmit(true);
            // const obj = {
            //     count: 0,
            //     items: [],
            // };
            // props.cartCountUpdate(obj);
            // props.selectedScenarioUuidList([])
            // props.selectedScenarioNameList([])
            props.setCurrentPageNumber(0);
            props.baseScenarioNameSelected(baseScenarioSelected.label);
            props.variationList(baseScenarioSelected.label, 1);
        } else {
            props.variationList();
        }
    }

    function openPopupModal() {
        setSelectAllVaritationPopup(true);
    }

    function closePopupModal() {
        setSelectAllVaritationPopup(false);
    }

    function onSelectTotalVariations(event) {
        setSelectedTotalVariation(event.target.value);
        // let text;
        if (
            isNaN(event.target.value) ||
            event.target.value < 0 ||
            event.target.value > props.variationInfo.total_variation_count
        ) {
            // text = "Input invalid";
            setSelectedTotalVariationFlag(false);
        } else {
            // text = "Input OK";
            setSelectedTotalVariation(event.target.value);
            if (isNaN(event.target.value)) {
                setSelectedTotalVariationFlag(false);
            } else {
                setSelectedTotalVariationFlag(true);
            }
        }
        // document.getElementById("demo").innerHTML = text;
    }

    let selectedScenarioObj = {};
    function submitSelectedVariation() {
        setDeselectBulkvariations(true)
        if (selectedTotalVariationFlag === false) {
            alert("Please fill required fields with correct data");
        } else {
            selectedScenarioObj = props.scenarioObjectListData;
            if (
                baseScenarioSelected["label"] in selectedScenarioObj &&
                parseInt(scenarioGroupNumber, 10) === 0
            ) {
                delete selectedScenarioObj[baseScenarioSelected["label"]];
            } else if (
                baseScenarioSelected["label"] in selectedScenarioObj &&
                scenarioGroupNumber !== 0
            ) {
                // delete selectedScenarioObj[baseScenarioSelected["label"]];
                selectedScenarioObj[baseScenarioSelected["label"]] = parseInt(
                    scenarioGroupNumber,
                    10
                );
            } else {
                selectedScenarioObj[baseScenarioSelected["label"]] = parseInt(
                    scenarioGroupNumber,
                    10
                );
            }
            props.bulkSelectedScenarioList(selectedScenarioObj);
            setSelectAllVaritationPopup(false);
            props.baseScenarioNameSelected(baseScenarioSelected.label);
            props.variationList(baseScenarioSelected.label, 1);

            let presentCount=0
            let variationCount = 0;
            if (Object.keys(props.scenarioObjectListData).length !== 0) {
                Object.values(props.scenarioObjectListData).forEach(
                    (val) => {
                        variationCount = variationCount + val
                        presentCount = val
                    }

                );
            }
            setData(prev => [...prev, [simulatorSelected.label, modelSeleted.label, versionSeleted.label, featureSelected.label, baseScenarioSelected.label, presentCount]])
            props.cartCount(variationCount);
        }
    }

    let selCount = 0;
    if(baseScenarioSelected){
        if (baseScenarioSelected["label"] in props.scenarioObjectListData) {
             selCount = props.scenarioObjectListData[baseScenarioSelected["label"]];
        }
    }
    return (
        <div className="col-lg-12">
            <div className="row" style={{ padding: "0.5rem" }}>
                <div
                    className="col-lg-4"
                    style={{
                        display: "inline-block",
                    }}
                >
                    <div
                        className="col-lg-12"
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Simulator :
                    </div>
                    <div className="col-lg-12" style={{ width: "100%" }}>
                        <VirtualizedSelect
                            options={simOptions}
                            onChange={(simulatorSelect) => {
                                setSimulatorSelected("");
                                setModelSeleted("");
                                setVersionSeleted("");
                                setFeatureSelected("");
                                setBaseScenarioSelected("")
                                if (simulatorSelect && simulatorSelect.label) {
                                    onSimulatorChange(simulatorSelect);
                                    props.modelList(simulatorSelect.label);
                                }
                            }}
                            value={simulatorSelected}
                        />
                    </div>
                </div>
                {/* {Object.keys(simulatorSelected).length > 0 ? ( */}
                <div
                    className="col-lg-4"
                    style={{
                        display: "inline-block",
                    }}
                >
                    <div
                        className="col-lg-12"
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Model :
                    </div>
                    <div className="col-lg-12" style={{ width: "100%" }}>
                        <VirtualizedSelect
                            options={modelOptions}
                            onChange={(modalSelect) => {
                                setModelSeleted("");
                                setVersionSeleted("");
                                setFeatureSelected("");
                                setBaseScenarioSelected("")
                                if (modalSelect && modalSelect.label) {
                                    onModelChange(modalSelect);
                                    props.versionList(modalSelect.label);
                                }
                            }}
                            value={modelSeleted}
                        />
                    </div>
                </div>
                {/* ) : undefined} */}
                {/* {Object.keys(modelSeleted).length > 0 ? ( */}
                <div
                    className="col-lg-4"
                    style={{
                        display: "inline-block",
                    }}
                >
                    <div
                        className="col-lg-12"
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Version :
                    </div>
                    <div className="col-lg-12" style={{ width: "100%" }}>
                        <VirtualizedSelect
                            options={modelVersionOptions}
                            onChange={(versionSelect) => {
                                setVersionSeleted("");
                                setFeatureSelected("");
                                setBaseScenarioSelected("")
                                if (versionSelect && versionSelect.label) {
                                    onVersionChange(versionSelect);
                                    props.featureList(modelSeleted.label);
                                }
                            }}
                            value={versionSeleted}
                        />
                    </div>
                </div>
                {/* ) : undefined} */}
            </div>
            <div className="row" style={{ padding: "0.5rem" }}>
                {/* {Object.keys(modelSeleted).length > 0 ? ( */}
                <div
                    className="col-lg-4"
                    style={{
                        display: "inline-block",
                    }}
                >
                    <div
                        className="col-lg-12"
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Feature :
                    </div>
                    <div className="col-lg-12" style={{ width: "100%" }}>
                        <VirtualizedSelect
                            options={featureOptions}
                            onChange={(featureSelect) => {
                                setFeatureSelected("");
                                setBaseScenarioSelected("")
                                if (featureSelect && featureSelect.label) {
                                    onFeatureChange(featureSelect);
                                    props.baseScenarioList(featureSelect.label);
                                }
                            }}
                            value={featureSelected}
                        />
                    </div>
                </div>
                {/* ) : undefined} */}
                {/* {Object.keys(featureSelected).length > 0 ? ( */}
                <div
                    className="col-lg-4"
                    style={{
                        display: "inline-block",
                    }}
                >
                    <div
                        className="col-lg-12"
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Base Scenario :
                    </div>
                    <div className="col-lg-12" style={{ width: "100%" }}>
                        <VirtualizedSelect
                            options={baseScenarioOptions}
                            onChange={(baseScenarioSelect) =>
                                onBaseScenarioChange(baseScenarioSelect)
                            }
                            value={baseScenarioSelected}
                        />
                    </div>
                </div>
                {/* ) : undefined} */}
                {/* {Object.keys(simulatorSelected).length > 0 ? ( */}
                <div
                    className="col-lg-4"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "1rem",
                    }}
                >
                    {/* <div className="col-lg-6" style={{ padding: "0% 10%" }}> */}
                    <button
                        className="btn"
                        style={{
                            backgroundColor: "#757AF7",
                            color: "#FFFFFF",
                            border: "0rem",
                            borderRadius: "0.2rem",
                            width: "9.5rem",
                        }}
                        onClick={submitDropDownMenu}
                        disabled={!baseScenarioSelected}
                    >
                        Submit
                        <i
                            className="fa fa-check"
                            aria-hidden="true"
                            style={{ margin: "0 0.5rem" }}
                        ></i>
                    </button>
                    {/* </div> */}

                    <div className="col-lg-6">
                        <button
                            className="btn"
                            style={{
                                backgroundColor: "#757AF7",
                                color: "#FFFFFF",
                                border: "0rem",
                                borderRadius: "0.2rem",
                                // padding: "0.5rem",
                                width: "10.5rem",
                            }}
                            disabled={simulatorSelected===""?true:false}
                            onClick={resetDropDownMenu}
                        >
                            Reset
                            <i
                                className="fa fa-sync"
                                aria-hidden="true"
                                style={{ margin: "0 0.5rem" }}
                            ></i>
                        </button>
                    </div>
                </div>
                {/* ) : undefined} */}
            </div>
            <div className="row" style={{ padding: "0.5rem" }}>
                {/* {Object.keys(baseScenarioSelected).length > 0 ? ( */}
                {/* <div
                    className="col-lg-4"
                    style={{
                        display: "inline-block",
                        textAlign: "center",
                    }}
                >
                    <button
                        className="btn"
                        style={{
                            backgroundColor: "#757AF7",
                            color: "#FFFFFF",
                            border: "0rem",
                            borderRadius: "0.2rem",
                            // padding: "0.5rem",
                            // width: "70%",
                            // float: "right",
                        }}
                        onClick={openPopupModal}
                        disabled={!onSubmit || props.count !== 0}
                    >
                        Select bulk variations
                        <i
                            className="fa fa-check"
                            aria-hidden="true"
                            style={{ margin: "0 0.5rem" }}
                        ></i>
                    </button>
                </div> */}
                <div
                    className="col-lg-4"
                    style={{
                        display: "inline-block",
                        textAlign: "center",
                    }}
                >
                    <Link
                        to={{
                            pathname: "/custom_maps",
                        }}
                        style={{ textDecoration: "none" }}
                        // target="_blank"
                    >
                        <button
                            className="btn"
                            style={{
                                backgroundColor: "#757AF7",
                                color: "#FFFFFF",
                                border: "0rem",
                                borderRadius: "0.2rem",
                                width: "16rem",
                            }}
                        >
                            Custom Maps
                            <i
                                className="fa fa-upload"
                                aria-hidden="true"
                                style={{ margin: "0rem 0.5rem" }}
                            ></i>
                        </button>
                    </Link>
                </div>
                <div
                    className="col-lg-4"
                    style={{
                        display: "inline-block",
                        textAlign: "center",
                    }}
                >
                    <Link
                        to={{
                            pathname: "/scenario_variation/upload_enhanced",
                        }}
                        style={{ textDecoration: "none" }}
                        // target="_blank"
                    >
                        {/* <button
                            className="btn"
                            style={{
                                backgroundColor: "#757AF7",
                                color: "#FFFFFF",
                                border: "0rem",
                                borderRadius: "0.2rem",
                                // padding: "0.5rem",
                                // width: "70%",
                                // float: "right",
                            }}
                            // onClick={openPopupModal}
                            // disabled={!onSubmit || props.count !== 0}
                        >
                            Upload variation
                            <i
                                className="fa fa-upload"
                                aria-hidden="true"
                                style={{ margin: "0rem 0.5rem" }}
                            ></i>
                        </button> */}
                        <button
                            className="btn"
                            style={{
                                backgroundColor: "#757AF7",
                                color: "#FFFFFF",
                                border: "0rem",
                                borderRadius: "0.2rem",
                                width: "16rem",
                                // padding: "0.5rem",
                                // width: "70%",
                                // float: "right",
                            }}
                            // onClick={openPopupModal}
                            // disabled={!onSubmit || props.count !== 0}
                        >
                            Scenario variation creation
                            <i
                                className="fa fa-upload"
                                aria-hidden="true"
                                style={{ margin: "0rem 0.5rem" }}
                            ></i>
                        </button>
                    </Link>
                </div>
                <div
                    className="col-lg-4"
                    style={{
                        display: "inline-block",
                        textAlign: "center",
                    }}
                >
                    <Link
                        to={{
                            pathname:
                                "close_loop_scenario_collection_enhanced/scenario_file/upload",
                        }}
                        style={{ textDecoration: "none" }}
                        // target="_blank"
                    >
                        <button
                            className="btn"
                            style={{
                                backgroundColor: "#757AF7",
                                color: "#FFFFFF",
                                border: "0rem",
                                borderRadius: "0.2rem",
                                // padding: "0.5rem",
                                width: "16rem",
                                // float: "right",
                            }}
                            // onClick={openPopupModal}
                            // disabled={!onSubmit || props.count !== 0}
                        >
                            Upload variation
                            <i
                                className="fa fa-upload"
                                aria-hidden="true"
                                style={{ margin: "0rem 0.5rem" }}
                            ></i>
                        </button>
                    </Link>
                </div>
                {/* ) : undefined} */}
            </div>
            <div className="row" style={{ padding: "0.5rem", justifyContent: "left" }}>
                {/* {Object.keys(baseScenarioSelected).length > 0 ? ( */}
                <div
                    className="col-lg-4"
                    style={{
                        display: "inline-block",
                        textAlign: "center",
                    }}
                >
                    <button
                        className="btn"
                        style={{
                            backgroundColor: "#757AF7",
                            color: "#FFFFFF",
                            border: "0rem",
                            borderRadius: "0.2rem",
                            width: "16rem",
                        }}
                        onClick={deselectBulkvariations ? resetCartData : openPopupModal}
                        disabled={!onSubmit || props.count !== 0}
                    >
                        {deselectBulkvariations ? "Deselect Bulk Variations" :
                                <div>
                                     Select bulk variations
                                     <i
                                         className="fa fa-check"
                                         aria-hidden="true"
                                         style={{ margin: "0 0.5rem" }}
                                     ></i>
                                 </div>
                         }
                    </button>
                </div>
                <div
                    className="col-lg-2"
                    style={{
                        display: "inline-block",
                    }}
                >
                    {/* <button
                        className="btn"
                        style={{
                            backgroundColor: "#007bff",
                            color: "#FFFFFF",
                            border: "0rem",
                            borderRadius: "0.2rem",
                            padding: "0.5rem",
                            width: "100%",
                        }}
                        disabled={!baseScenarioSelected}
                    >
                        Filter Variation
                        <i
                            class="fa fa-filter"
                            aria-hidden="true"
                            style={{ margin: "0 0.5rem" }}
                        ></i>
                    </button> */}
                </div>
                {/* ) : undefined} */}
            </div>
            {selectAllVaritationPopup ? (
                <Modal isOpen={selectAllVaritationPopup}>
                    {/* <Modal isOpen={true}> */}
                    <ModalHeader>Select Bulk Variations</ModalHeader>
                    {/* {props.error ? (
                            <Alert key="danger" variant="danger">
                                {props.error}
                            </Alert>
                        ) : null} */}
                    <ModalBody>
                        <div className="card">
                            <div
                                className="card-body"
                                style={{
                                    padding: "1rem",
                                }}
                            >
                                {/* {props.count === 0 ? (
                                        <p>Please Select Scenarios</p>
                                    ) : (
                                        <div className="form-group">
                                            <h5 style={{ color: "#008000" }}>
                                                Selected scenario variations : {props.count}{" "}
                                            </h5>
                                            Scenario Group Name{" "}
                                            <input
                                                type="text"
                                                className="form-control"
                                                list="data"
                                                // onChange={onScenarioGroupNameChange}
                                                required
                                            />
                                            <div>
                                                Expected Group Number
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    // onChange={onScenarioGroupNumberChange}
                                                    required
                                                />
                                                <p style={{ color: "#FF0000" }} id="demo"></p>
                                            </div>
                                        </div>
                                    )} */}
                                <div className="row">
                                    <div
                                        className="col-lg-12"
                                        style={{
                                            padding: "0.5rem",
                                        }}
                                    >
                                        <div
                                            className="col-lg-5"
                                            style={{
                                                // textAlign: "center",
                                                display: "inline-block",
                                                padding: "0.5rem",
                                                backgroundColor: "#e2e3ff",
                                            }}
                                        >
                                            Base Scenario :
                                        </div>
                                        <div
                                            className="col-lg-7"
                                            style={{
                                                textAlign: "center",
                                                display: "inline-block",
                                                padding: "0.5rem",
                                                backgroundColor: "#e2e3ff",
                                            }}
                                        >
                                            {baseScenarioSelected["label"]}
                                            {/* basa */}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div
                                        className="col-lg-12"
                                        style={{
                                            padding: "0.5rem",
                                        }}
                                    >
                                        <div
                                            className="col-lg-7"
                                            style={{
                                                // textAlign: "center",
                                                display: "inline-block",
                                                padding: "0.5rem",
                                                backgroundColor: "#e2e3ff",
                                            }}
                                        >
                                            Total selected variation :
                                        </div>
                                        <div
                                            className="col-lg-5"
                                            style={{
                                                textAlign: "center",
                                                display: "inline-block",
                                                padding: "0.5rem",
                                                backgroundColor: "#e2e3ff",
                                            }}
                                        >
                                            {selCount} / {props.variationInfo.total_variation_count}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div
                                        className="col-lg-12"
                                        style={{
                                            padding: "0.5rem",
                                        }}
                                    >
                                        <div
                                            className="col-lg-7"
                                            style={{
                                                // textAlign: "center",
                                                display: "inline-block",
                                                padding: "0.5rem",
                                                backgroundColor: "#e2e3ff",
                                            }}
                                        >
                                            Select total variation :
                                        </div>
                                        <div
                                            className="col-lg-5"
                                            style={{
                                                textAlign: "center",
                                                display: "inline-block",
                                                // padding: "0.5rem",
                                                backgroundColor: "#e2e3ff",
                                            }}
                                        >
                                            <input
                                                type="number"
                                                className="form-control"
                                                // list="data"
                                                onChange={onSelectTotalVariations}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {/* {props.count === 0 || props.error ? undefined : ( */}
                        <Button
                            className="btn"
                            style={{ backgroundColor: "#757AF7" }}
                            onClick={submitSelectedVariation}
                        >
                            Add To Cart
                        </Button>
                        {/* )} */}
                        <Button
                            className="btn"
                            style={{ backgroundColor: "#757AF7" }}
                            onClick={closePopupModal}
                        >
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
            ) : undefined}
        </div>
    );
}

const mapStateToProps = (state) => ({
    simulatorListInfo: state.DropDownSimulatorData.simulatorListInfo,
    modelListInfo: state.DropDownModelData.modelListInfo,
    modelVersionListInfo: state.DropDownModelVersionData.modelVersionListInfo,
    featureListInfo: state.DropDownFeatureReducer.featureListInfo,
    baseScenarioListInfo: state.DropDownBaseScenarioReducer.baseScenarioListInfo,
    variationInfo: state.DropDownSubmitReducer.variationListInfo,
    scenarioObjectListData: state.addBulkScenariosToListStatus.selectedScenarioObjectList,
    count: state.addToCartScenarioCollectionData.count,
});

const mapDispatchToProps = (dispatch) => ({
    simulatorList: () => dispatch(fetchSimulatorInfo()),
    modelList: (simulator) => dispatch(fetchModelInfo(simulator)),
    versionList: (model) => dispatch(fetchModelVersionInfo(model)),
    featureList: (model) => dispatch(fetchFeatureInfo(model)),
    baseScenarioList: (feature) => dispatch(fetchBaseScenarioInfo(feature)),
    variationList: (baseScenario, page) => dispatch(fetchVariationListInfo(baseScenario, page)),
    baseScenarioNameSelected: (baseScenarioSelected) =>
        dispatch(selectedBaseScenario(baseScenarioSelected)),
    cartCountUpdate: (obj) => dispatch(cartCountUpdate(obj)),
    selectedScenarioUuidList: (variationUuid) => dispatch(selectedScenarioUuidList(variationUuid)),
    selectedScenarioNameList: (variationName) => dispatch(selectedScenarioNameList(variationName)),
    bulkSelectedScenarioList: (scenarioObject) =>
        dispatch(bulkSelectedScenarioList(scenarioObject)),
    cartCount: (variationCount) => dispatch(cartCount(variationCount)),
    setCurrentPageNumber: (currentPageNumber) => dispatch(setCurrentPageNumber(currentPageNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(dropDownModal);
